import { createWebHistory, createRouter } from "vue-router";
// import axios from "axios";
import routes from "./routes";
// import appConfig from "../../app.config";
// import store from "@/state/store";
import { publicPath } from "../../vue.config";
import { saveAuthData } from "@/common/helper/auth.helper";
import AuthService from "@/services/authService";
import alert from "@/common/helper/alert.helper";

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_PUBLIC_PATH),
  base: publicPath,
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else {
      return { top: 0, left: 0 };
    }
  },
});

let isValidatingToken = false;

function showTokenInvalid(message) {
  return new Promise((resolve) => {
    alert.failed(message || "Token tidak valid", () => resolve());
  });
}

const nextFactory = function (context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;
  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
};

router.beforeEach(async (to, from, next) => {
  let tokenQuery = to.query.token;
  if (tokenQuery) {
    if (isValidatingToken) {
      next(false);
      return;
    }
    isValidatingToken = true;
    let query = { ...to.query };
    delete query.token;

    let result;
    try {
      result = await AuthService.validate(tokenQuery);
    } catch (error) {
      result = { status: 500, message: "Terjadi kesalahan koneksi" };
    }

    if (result && result.status === 200) {
      const menuPath = await saveAuthData(result.data).catch(() => null);
      isValidatingToken = false;
      next({ path: menuPath || "/dashboard", query });
      return;
    } else {
      isValidatingToken = false;
      await showTokenInvalid(result && result.message);
      next({ path: "/login", query });
      return;
    }
  }

  if (from.name) {
    localStorage.setItem('previousRoute', from.fullPath);
  }
  
  const reqLogout = to.matched.some((record) => record.meta.reqLogout); // false
  const authRequired = to.matched.some((record) => record.meta.authRequired); // false
  const reqToken = !!localStorage.getItem("token"); // false
  if (to.path === '/collective-payment/download-pdf/') {
    localStorage.setItem('isLoginQR', true);
    localStorage.setItem('queryPdf', JSON.stringify(to.query));
  }

  const isMiddleware = to.matched.some((record) => record.meta.middleware); // false
  if (isMiddleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
  }

  if (authRequired === true) {
    if (reqToken === false) {
      next("/login");
    } else {
      next();
    }
  } else {
    // if reqAuth = false
    // eslint-disable-next-line no-lonely-if
    if (reqToken === true && reqLogout === true) {
      next("/");
    } else {
      next();
    }
  }


  // if(removeMerchantId === true) {
  //   localStorage.removeItem('merchantId')
  // }

  // if(removeStoreId === true) {
  //   localStorage.removeItem('storeId')
  // }
});

export default router;
